import { render, staticRenderFns } from "./InputNumberSetting.vue?vue&type=template&id=2cd99cba&scoped=true&"
import script from "./InputNumberSetting.vue?vue&type=script&lang=js&"
export * from "./InputNumberSetting.vue?vue&type=script&lang=js&"
import style0 from "./InputNumberSetting.vue?vue&type=style&index=0&id=2cd99cba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd99cba",
  null
  
)

export default component.exports